<template>
	<header class="topo topo--mobile" ref="$topo">
		<div class="mobile__controls" ref="$mblControls">
			<div class="logo">
				<slot name="logo1" />

				<slot name="logo2" />
			</div>

			<button
				type="button"
				class="btn btn-mobile-toggle"
				@click.prevent="openMenu"
				aria-label="Menu"
				:aria-expanded="JSON.stringify(shown)"
				:class="{
					active: shown
				}"
			><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 448 512"><path d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"/></svg></button>
		</div><!--/.mobile__controls-->

		<!-- MAIN MENU -->
		<keep-alive>
			<transition
				enter-active-class="fadeInLeft animated"
				leave-active-class="fadeOutLeft animated"
			>
				<div
					v-if="shown"
					class="topo__main"
				>
					<div class="logo">
						<slot name="logo1" />

						<slot name="logo2" />
					</div>

					<slot name="menu"></slot>
				</div>
			</transition>
		</keep-alive>

		<!-- BACKDROP -->
		<keep-alive>
			<transition
				enter-active-class="fadeIn animated"
				leave-active-class="fadeOut animated"
			>
				<div
					v-if="shown"
					class="menu__backdrop"
					@click.prevent="closeMenu"
				></div>
			</transition>
		</keep-alive>
	</header>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import State, { openMenu, closeMenu } from './state'

const shown        = computed(() => State.menu.open)

const $mblControls = ref(null)
const $topo        = ref(null)

onMounted(() => {
	const check = () => {
		$topo.value.style.setProperty('height', `${$mblControls.value.offsetHeight}px`)

		requestAnimationFrame(check)
	};

	requestAnimationFrame(check)
})
</script>
